'use strict';
const moment = require("moment");

angular.module('mean.accounting').controller('PayrollController',
    ['$scope', '$filter', '$http', '$q', 'Global', 'Users', 'Charts', 'toaster', 'MeanUser', 'Trades', 'GeneralTasks', 'PayrollProcess', 'PayrollRules', 'Projects', 'aceUtils', 'tradeCodeService', 'ngDialog', 'PayrollSetup', 'userService', 'ProjectBids', 'costTotalService',
        function ($scope, $filter, $http, $q, Global, Users, Charts, toaster, MeanUser, Trades, GeneralTasks, PayrollProcess, PayrollRules, Projects, aceUtils, tradeCodeService, ngDialog, PayrollSetup, userService, ProjectBids, costTotalService) {

            $scope.global = Global;
            $scope.user = MeanUser.user;
            $scope.menu = ['SETUP', 'PROCESS'];
            $scope.appliedTo = ['Per Employee', 'Company Wide'];
            $scope.dataPoints = ['Wage Total', 'Payroll Taxes', 'Workers Comp.'];
            $scope.accounts = [];
            $scope.payrollRules = [];
            $scope.selectedRule = null;
            $scope.clientAccountId = '';
            $scope.userStatus = true;
            $scope.minDateMoment = moment();
            $scope.employeeList = [];
            $scope.selectedTabs = 'setup';
            $scope.submitMode = '';
            $scope.sortReverse = false;

            $scope.strFormat = 'DD MMM YYYY';
            $scope.payperiods = [];
            $scope.startDate = new Date();
            $scope.endDate = new Date();

            $scope.all_tasks = [];
            $scope.cost_center = [];
            $scope.projectBids = [];
            $scope.opened = false;
            $scope.nextDisabled = false;
            $scope.selDateRange = [];
            $scope.selParollPeriod = null;
            $scope.showSpinner = false;
            var importEmployeeAPI = '/api/accounting/importEmployeeAPI';
            $scope.tradeProjects = null;
            $scope.init = function () {
                userService.getMainAccountId($scope.user.username).then(function (id) {
                    $scope.clientAccountId = id;

                    Trades.query({ 'main_account_id': $scope.clientAccountId }, function (trade) {
                        $scope.users_trade_account = trade[0];
                        $scope.getEmployeeList();
                        trade[0].company_code = aceUtils.padDigits(trade[0].company_code, 3);
                        trade[0].trade_code = tradeCodeService.getCode(trade[0].trade);
                        $scope.setPayPeriods();
                        $scope.getTadeProjects(trade[0].trade_code, trade[0].company_code);
                    });
                    GeneralTasks.query({}, function (tasks) {
                        $scope.all_tasks = $filter('orderBy')(tasks, 'order');
                    });

                    var currentCharQuery = {
                        type: 'TRAN_ACCOUNT',
                        isDeleted: false,
                        status: 'Active',
                        userId: $scope.clientAccountId
                    };

                    // Get charts of Account
                    Charts.query(currentCharQuery, function (accounts) {
                        $scope.accounts = accounts;
                    });

                    $scope.getPayrollRules();
                })
            };

            $scope.getTadeProjects = function (trade_code, company_code) {
                Projects.query({
                    'type': 'payrollProject',
                    'trade_code': trade_code,
                    'company_code': company_code
                }, function (projects) {
                    $scope.tradeProjects = _.groupBy(projects, '_id');
                });
            }

            $scope.getCostCenter = function (user) {
                var tasks = [];
                var projectTypes = [];
                var geoLocations = [];
                if (user.combination.length) {
                    for (var i = 0; i < user.combination.length; i++) {
                        projectTypes.push(user.combination[i].projectType);
                        geoLocations.push(user.combination[i].geoLocation);
                    }
                }

                tasks = $scope.all_tasks.filter(item => {
                    return (projectTypes.indexOf(item.projectType) !== -1 && geoLocations.indexOf(item.geoLocation) !== -1);
                })
                $scope.cost_center = tasks;
            }

            $scope.open = function ($event) {
                $event.preventDefault();
                $event.stopPropagation();
                $scope.opened = true;
            };

            $scope.onSelect = function (tab) {
                $scope.selectedTabs = tab;
                $scope.selDateRange = [];
                $scope.selectedPayPeriod = null;
                $scope.reportDateRange = null;
            }

            $scope.changeValue = function () {
                $scope.userStatus = this.userStatus;
                $scope.getEmployeeList();
            }

            $scope.getEmployeeList = function () {
                var queryObj = {
                    'contractor_code': $scope.user.contractor_code,
                    'trade': $scope.user.trade[0]
                };

                if ($scope.userStatus) {
                    queryObj['type'] = 'status';
                    queryObj['status'] = 'true';
                } else {
                    queryObj['type'] = 'All';
                }
                $scope.showSpinner = true;
                PayrollSetup.query(queryObj, function (result) {
                    if (result.length) {
                        $scope.employeeList = result;
                    } else {
                        $scope.nextDisabled = true;
                    }
                    $scope.showSpinner = false;
                })
            };

            $scope.editEmployeeInfo = function (id) {
                var editEmployee = $scope.employeeList.filter(item => item._id === id);
                $scope.addEmployeeObj = angular.copy(editEmployee[0]);
                $scope.addEmployeeObj.hiredDate = moment($scope.addEmployeeObj.hiredDate);
                $scope.getCostCenter($scope.addEmployeeObj);
                ngDialog.openConfirm({
                    template: 'accounting/views/payrolls/addPayroll.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg employeeInfo'
                }).then(function (value) {
                    value.$update(function (result) {
                        $scope.getEmployeeList();
                    },
                        function (error) {
                            toaster.pop('error', 'Error', error);
                        });
                    $scope.opened = false;
                }, function (value) {
                    $scope.opened = false;
                });
            };

            $scope.incrementPayPeriod = function (period) {
                if (period === 'weekly') {
                    $scope.payEndDate.add(7, 'days');
                } else if (period === 'biweekly') {
                    $scope.payEndDate.add(14, 'days');
                }

                var startDate;

                if (period === 'weekly') {
                    startDate = moment($scope.payEndDate).subtract(6, 'days');
                } else if (period === 'biweekly') {
                    startDate = moment($scope.payEndDate).subtract(13, 'days');
                }

                $scope.payperiods.push({
                    start: moment(startDate),
                    end: moment($scope.payEndDate).endOf('day'),
                    string: startDate.format($scope.strFormat) + ' - ' + $scope.payEndDate.format($scope.strFormat)
                });

                if ($scope.payStartDate <= $scope.payToday && $scope.payToday <= $scope.payEndDate) {
                    $scope.payStartDate = moment(startDate);
                    return -1;
                }
                else
                    return 0;
            };

            $scope.setPayPeriods = function () {

                if (!$scope.users_trade_account.payroll_end_date || !$scope.users_trade_account.payroll_period) {
                    toaster.pop('error', 'No Payroll Settings', 'Please set payroll settings in Company Admin');
                    return;
                }

                $scope.payStartDate = moment($scope.users_trade_account.payroll_end_date).add(1, 'day');
                $scope.payEndDate = moment($scope.users_trade_account.payroll_end_date).add(1, 'day');
                if ($scope.users_trade_account.payroll_period === 'weekly') {
                    $scope.payEndDate.add(6, 'day');
                } else if ($scope.users_trade_account.payroll_period === 'biweekly') {
                    $scope.payEndDate.add(13, 'day');
                }

                $scope.payToday = moment();
                while ($scope.incrementPayPeriod(
                    $scope.users_trade_account.payroll_period) !== -1) {
                }

                $scope.payperiods.reverse();
                $scope.payperiods.map(item => {
                    var startD = new Date(item.start);
                    var endDate = new Date(item.end);
                    startD.setHours(0);
                    startD.setMinutes(0);
                    startD.setSeconds(0);
                    endDate.setHours(23);
                    endDate.setMinutes(59);
                    endDate.setSeconds(59);
                    item['start'] = startD;
                    item['end'] = endDate;
                    return item;
                });
            };

            $scope.changePayPeriod = function () {
                if (!this.selectedPayPeriod) return;
                $scope.reportDateRange = null;
                $scope.startDate = new Date(this.selectedPayPeriod.start);
                $scope.endDate = new Date(this.selectedPayPeriod.end);

                $scope.startDate.setHours(0);
                $scope.startDate.setMinutes(0);
                $scope.startDate.setSeconds(0);
                $scope.endDate.setHours(23);
                $scope.endDate.setMinutes(59);
                $scope.endDate.setSeconds(59);
                $scope.submitMode = 'payPariod';
            };

            $scope.dateRangeUpdated = function () {
                if (!this.reportDateRange) return;
                $scope.selectedPayPeriod = null;

                $scope.startDate = new Date(this.reportDateRange.startDate);
                $scope.endDate = new Date(this.reportDateRange.endDate);

                $scope.startDate.setHours(0);
                $scope.startDate.setMinutes(0);
                $scope.startDate.setSeconds(0);
                $scope.endDate.setHours(23);
                $scope.endDate.setMinutes(59);
                $scope.endDate.setSeconds(59);
                $scope.submitMode = 'dateRange';

            };

            $scope.editOfficeHours = function (item) {
                item.officeHoursEditing = true;
            };

            $scope.doneOfficeHoursEditing = function (item, childs) {
                if (item.officeHours === null) return;
                $scope.selParollPeriod['users'][childs]['officeHours'] = Number(item.officeHours);
                $scope.recalculate($scope.selParollPeriod);
                item.officeHoursEditing = false;
            };

            $scope.editOfficeOverTime = function (item) {
                item.officeOverTimeEditing = true;
            };

            $scope.doneOfficeOverTimeEditing = function (item, childs) {
                if (item.officeHoursOverTime === null) return;
                $scope.selParollPeriod['users'][childs]['officeHoursOverTime'] = Number(item.officeHoursOverTime);
                $scope.recalculate($scope.selParollPeriod);
                item.officeOverTimeEditing = false;
            };

            $scope.editOfficeDoubleTime = function (item) {
                item.officeDoubleTimeEditing = true;
            };

            $scope.doneOfficeDoubleTimeEditing = function (item, childs) {
                if (item.officeHoursDoubleTime === null) return;
                $scope.selParollPeriod['users'][childs]['officeHoursDoubleTime'] = Number(item.officeHoursDoubleTime);
                $scope.recalculate($scope.selParollPeriod);
                item.officeDoubleTimeEditing = false;
            };

            $scope.editOfficeBonus = function (item) {
                item.officeBonusEditing = true;
            };

            $scope.doneOfficeBonusEditing = function (item, childs) {
                if (item.officeBonus === null) return;
                $scope.selParollPeriod['users'][childs]['officeBonus'] = Number(item.officeBonus);
                $scope.recalculate($scope.selParollPeriod);
                item.officeBonusEditing = false;
            };

            $scope.editPtoRateEditing = function (item) {
                item.ptoRateEditing = true;
            };

            $scope.donePtoRateEditing = function (item, childs) {
                if (item.ptoHourAcc.hourAccured === null) return;
                $scope.selParollPeriod['users'][childs]['ptoHourAcc']['hourAccured'] = Number(item.ptoHourAcc.hourAccured);
                $scope.recalculate($scope.selParollPeriod);
                item.ptoRateEditing = false;
            };

            $scope.editPtoHoursEditing = function (item) {
                item.ptoHoursEditing = true;
            };

            $scope.donePtoHoursEditing = function (item, childs) {
                if (item.ptoHourAcc.hourWorked === null) return;
                $scope.selParollPeriod['users'][childs]['ptoHourAcc']['hourWorked'] = Number(item.ptoHourAcc.hourWorked);
                $scope.recalculate($scope.selParollPeriod);
                item.ptoHoursEditing = false;
            };

            $scope.recalculate = function (singleRange) {

                singleRange['fieldCount'] = 0;
                singleRange['totalFieldWages'] = 0;
                singleRange['officeCount'] = 0;
                singleRange['totalOffileWages'] = 0;
                singleRange['totalsWages'] = 0;
                singleRange['totalsPTO'] = 0;
                singleRange['extPayrollTaxes'] = 0;
                singleRange['extWorkComp'] = 0;

                var userPromisses = [];
                angular.forEach(singleRange['users'], function (user) {
                    let deferred = $q.defer();

                    let hoursPromisses = [];
                    angular.forEach(user['hoursData'], function (hour) {
                        hoursPromisses.push($scope.getPayRollTaxTotals(hour));
                    });

                    // hours promisses
                    $q.all(hoursPromisses).then(function (hours) {
                        user['hoursData'] = hours;
                        userPromisses.push(deferred.promise);
                    });
                });

                $q.all(userPromisses).then(function (res) {
                    _.each(singleRange['users'], (userHours) => {
                        let totalSalary = 0;
                        let annualSalary = angular.copy(userHours['annualSalary']);
                        if ($scope.users_trade_account.payroll_period === 'weekly') {
                            totalSalary = isNaN(annualSalary) ? 0 : (annualSalary / 52).toFixed(2);
                        } else if ($scope.users_trade_account.payroll_period === 'biweekly') {
                            totalSalary = isNaN(annualSalary) ? 0 : (annualSalary / 26).toFixed(2);
                        }

                        userHours['salary'] = Number(totalSalary);
                        userHours['hours'] = 0;
                        userHours['hours_over_time'] = 0;
                        userHours['hours_double_time'] = 0;
                        userHours['production_bonus'] = 0;
                        userHours['extra_break_money'] = 0;
                        userHours['premium_overtime'] = 0;
                        userHours['payroll_taxes'] = 0;
                        userHours['workers_comp'] = 0;

                        let fieldHours = 0;
                        let payrollTaxes = 0;
                        let payrollCamp = 0;
                        let hoursTotals = 0;

                        _.each(userHours['hoursData'], data => {
                            if (!isNaN(data['hours'])) {
                                fieldHours += data['hours'];
                            }
                            !isNaN(data['hours']) && (userHours['hours'] += data['hours']);
                            !isNaN(data['hours_over_time']) && (userHours['hours_over_time'] += Number(data['hours_over_time']));
                            !isNaN(data['hours_double_time']) && (userHours['hours_double_time'] += Number(data['hours_double_time']));
                            !isNaN(data['production_bonus']) && (userHours['production_bonus'] += Number(data['production_bonus']));
                            !isNaN(data['extra_break_money']) && (userHours['extra_break_money'] += Number(data['extra_break_money']));
                            !isNaN(data['premium_overtime']) && (userHours['premium_overtime'] += Number(data['premium_overtime']));

                            payrollTaxes += angular.copy(data['payroll_taxes']);
                            payrollCamp += angular.copy(data['workers_comp']);
                            hoursTotals += angular.copy(data['pay_total']);
                        });
                        let officeHours = (isNaN(userHours['officeHours']) ? 0 : userHours['officeHours']);
                        let officeHourRate = (isNaN(userHours['officeHourRate']) ? 0 : userHours['officeHourRate']);
                        let officeHoursOverTime = (isNaN(userHours['officeHoursOverTime']) ? 0 : userHours['officeHoursOverTime']);
                        let officeHoursDoubleTime = (isNaN(userHours['officeHoursDoubleTime']) ? 0 : userHours['officeHoursDoubleTime']);
                        let officeBonus = (isNaN(userHours['officeBonus']) ? 0 : userHours['officeBonus']);
                        let officePayTotals = (officeHours * officeHourRate) + (officeHoursOverTime * officeHourRate * 0.5) + (officeHoursDoubleTime * officeHourRate);

                        singleRange['totalOffileWages'] += (officePayTotals + officeBonus + userHours['salary']);
                        singleRange['totalFieldWages'] += hoursTotals;

                        if (userHours['salary'] > 0 || officeHours > 0) {
                            singleRange['officeCount'] += 1;
                        } else {
                            singleRange['fieldCount'] += 1;
                        }

                        // PTO Hours total added to totals wages
                        let PTOHours = (isNaN(Number(userHours['ptoHourAcc']['hourWorked'])) ? 0 : Number(userHours['ptoHourAcc']['hourWorked']));
                        let PTORate = (isNaN(Number(userHours['ptoHourAcc']['hourAccured'])) ? 0 : Number(userHours['ptoHourAcc']['hourAccured']));
                        singleRange['totalsPTO'] += (PTOHours * PTORate);
                        userHours['pay_total'] = userHours['salary'] + hoursTotals + officePayTotals + officeBonus + (PTOHours * PTORate);
                        singleRange['totalsWages'] += userHours['pay_total'];

                        // office tax and field info tax
                        let officeWCRate = 0;
                        if (!isNaN(Number(userHours['officeWCRate'])) && Number(userHours['officeWCRate']) !== 0) {
                            let wcRate = angular.copy(userHours['officeWCRate']);
                            officeWCRate = (wcRate / 100);
                        }
                        let officeWagesTaxes = officePayTotals * Number($scope.users_trade_account.costs.payroll_taxes);
                        let pTOHoursTaxes = ((PTOHours * PTORate) * Number($scope.users_trade_account.costs.payroll_taxes));
                        let salaryTax = (Number(userHours['salary'])  * Number($scope.users_trade_account.costs.payroll_taxes));
                        let officeWorkCompTaxes = officePayTotals * Number(officeWCRate);

                        singleRange['extPayrollTaxes'] += (payrollTaxes + officeWagesTaxes + pTOHoursTaxes + salaryTax);
                        singleRange['extWorkComp'] += (payrollCamp + officeWorkCompTaxes);

                        userHours['payroll_taxes'] = (payrollTaxes + officeWagesTaxes + pTOHoursTaxes + salaryTax);
                        userHours['workers_comp'] = (payrollCamp + officeWorkCompTaxes);

                    });
                });

                $scope.selParollPeriod = singleRange;
            }

            $scope.ConvertPayrollToCSV = function (objectData) {
                var payrollData = typeof objectData != 'object' ? JSON.parse(objectData) : objectData;
                var str = 'Payroll Period, Field Count, Total Field wages, Office Count, Total Office Wages, PTO Wages, Total Wages, Est Payroll Taxes, Est Works Comp, Submitted Date';
                str += ',,,,,,,,,,,';
                str += '\r\n';

                var startDate = new Date(payrollData.start);
                var endDate = new Date(payrollData.end);
                var submitDate = new Date(payrollData.submitedDate);
                var dateString = !isNaN(submitDate.getTime())
                    ? ("0" + (submitDate.getMonth() + 1)).slice(-2) + "-" + ("0" + submitDate.getDate()).slice(-2) + "-" + submitDate.getFullYear()
                    : '';

                var datestring1 = ("0" + (startDate.getMonth() + 1)).slice(-2) + "-" + ("0" + startDate.getDate()).slice(-2) + "-" + startDate.getFullYear();
                var datestring2 = ("0" + (endDate.getMonth() + 1)).slice(-2) + "-" + ("0" + endDate.getDate()).slice(-2) + "-" + endDate.getFullYear();

                str += datestring1 + ' to ' + datestring2 + ',' + payrollData.fieldCount + ', ' + '$' + payrollData.totalFieldWages + ',';
                str += payrollData.officeCount + ', ' + '$' + payrollData.totalOffileWages + ', ' + '$' + payrollData.totalsPTO + ', ' + '$' + payrollData.totalsWages + ',';
                str += '$' + payrollData.extPayrollTaxes + ', ' + '$' + payrollData.extWorkComp + ', ' + dateString;
                str += ',,,,,,,,,,,';
                str += '\r\n';

                str += 'Employee Name, Employee No, Field Hours, Field Hours Over Time, Field Hours Double Time, Field Hourly Rate,';
                str += 'Production Bonus, Extra Break Money, Premium Overtime, Office Hours, Office Hours Over Time, Office Hours Double Time, Office Hourly Rate, Anual Salary, Office Bonus, ';
                str += 'PTO Hours, PTO Hourly Rate, Total Wages, Payroll Taxes, Worker Comp';
                str += '\r\n';

                for (var i = 0; i < payrollData.users.length; i++) {
                    str += $scope.csvArrayFields(payrollData.users[i]);
                    str += '\r\n';
                }
                return str;
            };

            $scope.csvArrayFields = function (user) {
                var dataArray = [];
                dataArray.push(user.name);
                dataArray.push(user.username);

                dataArray.push(user.hours.toFixed(2));
                dataArray.push(user.hours_over_time.toFixed(2));
                dataArray.push(user.hours_double_time.toFixed(2));
                dataArray.push('$' + user.pay_rate.toFixed(2));
                dataArray.push('$' + user.production_bonus.toFixed(2));
                dataArray.push('$' + user.extra_break_money.toFixed(2));
                dataArray.push(user.premium_overtime);

                dataArray.push(user.officeHours);
                dataArray.push(user.officeHoursOverTime);
                dataArray.push(user.officeHoursDoubleTime);
                dataArray.push('$' + user.officeHourRate.toFixed(2));
                dataArray.push(user.salary);
                dataArray.push('$' + user.officeBonus.toFixed(2));

                dataArray.push(user.ptoHourAcc.hourWorked);
                dataArray.push('$' + user.ptoHourAcc.hourAccured.toFixed(2));

                dataArray.push('$' + user.pay_total.toFixed(2));
                dataArray.push('$' + user.payroll_taxes.toFixed(2));
                dataArray.push('$' + user.workers_comp.toFixed(2));

                return dataArray.join(',');
            }

            $scope.exportPayrollFile = function () {
                if (!$scope.selParollPeriod) {
                    toaster.pop('error', 'Error', 'No data to export.');
                    return;
                }
                var dataUrl = 'data:text/csv;charset=utf-8,' + ($scope.ConvertPayrollToCSV($scope.selParollPeriod));
                var link = document.createElement('a');
                angular.element(link)
                    .attr('href', dataUrl)
                    .attr('download', 'payroll_process.csv'); // Pretty much only works in chrome
                link.click();
            };

            $scope.getPayrollEmployee = function () {
                if (!$scope.startDate || !$scope.endDate || !$scope.submitMode) {
                    toaster.pop('error', 'Error', 'Please select date range.');
                    return;
                }
                $scope.selDateRange = [];
                $scope.quetyDateRange = [];
                if ($scope.submitMode === 'payPariod') {
                    var startDat = angular.copy($scope.startDate);
                    var endDat = angular.copy($scope.endDate);
                    var seleObj = {
                        start: new Date(startDat),
                        end: new Date(endDat)
                    }
                    $scope.quetyDateRange.push(seleObj);
                } else {
                    _.each($scope.payperiods, function (item) {
                        if (item.start >= moment($scope.startDate) && item.end <= moment($scope.endDate)) {
                            var obj = angular.copy(item);
                            delete obj['string'];
                            $scope.quetyDateRange.push(obj);
                        }
                    })
                    if ($scope.quetyDateRange.length) {
                        $scope.quetyDateRange = $scope.quetyDateRange.slice(-10);
                    }
                }

                if (!$scope.quetyDateRange.length) {
                    toaster.pop('error', 'Error', 'Please select valid date range.');
                    return;
                }
                $scope.showSpinner = true;
                Users.query({
                    'type': 'salaryProcessing',
                    'trade': $scope.user.trade[0],
                    'contractor_code': $scope.user.contractor_code
                }, function (users) {

                    PayrollProcess.query({
                        dateRange: JSON.stringify($scope.quetyDateRange),
                        trade: $scope.user.trade[0],
                        company_code: $scope.user.contractor_code
                    }, function (response) {
                        $scope.showSpinner = false;

                        var results = response[1]
                        var savedData = response[0];

                        $scope.selDateRange = angular.copy($scope.quetyDateRange);

                        for (var key in savedData) {
                            if (savedData.hasOwnProperty(key) && savedData[key][0]) {
                                $scope.selDateRange.forEach(function (item, index, object) {
                                    var startDate = new Date(item.start);
                                    var startDate2 = new Date(savedData[key][0].start);
                                    if (startDate.getTime() == startDate2.getTime()) {
                                        $scope.selDateRange[index] = savedData[key][0];
                                    }
                                });
                            }
                        }

                        _.each($scope.selDateRange, (singleRange, indexNo) => {
                            if (!singleRange.hasOwnProperty('_id')) {
                                var hoursRangeObj = results[indexNo];
                                var userCopy = angular.copy(users);
                                // add field Info field to users
                                userCopy.map(item => {

                                    var totalSalary = 0;
                                    var annualSalary = angular.copy(item['annualSalary']);
                                    if ($scope.users_trade_account.payroll_period === 'weekly') {
                                        totalSalary = isNaN(annualSalary) ? 0 : (annualSalary / 52).toFixed(2);
                                    } else if ($scope.users_trade_account.payroll_period === 'biweekly') {
                                        totalSalary = isNaN(annualSalary) ? 0 : (annualSalary / 26).toFixed(2);
                                    }

                                    item['salary'] = Number(totalSalary);
                                    item['hours'] = 0;
                                    item['hours_over_time'] = 0;
                                    item['hours_double_time'] = 0;
                                    item['production_bonus'] = 0;
                                    item['officeHours'] = 0;
                                    item['officeHoursOverTime'] = 0;
                                    item['officeHoursDoubleTime'] = 0;
                                    item['officeBonus'] = 0;
                                    item['extra_break_money'] = 0;
                                    item['premium_overtime'] = 0;
                                    item['pay_total'] = 0;
                                    item['payroll_taxes'] = 0;
                                    item['workers_comp'] = 0;
                                    item['ptoHourAcc'] = { 'hourWorked': 0, 'hourAccured': 0  };

                                    var hors = [];
                                    for (var key in hoursRangeObj) {
                                        if (hoursRangeObj.hasOwnProperty(key)) {
                                            var hObjects = $filter('filter')(hoursRangeObj[key], { _id: item['username'] }, true);
                                            if (hObjects.length) {
                                                hors = hObjects[0].matchData
                                            }
                                        }
                                    }
                                    item['hoursData'] = hors;

                                    return item;
                                });

                                userCopy = _.filter(userCopy, function (item, index) {
                                    return ((!item.active && item.hoursData.length) || item.active);
                                });

                                // row fields
                                singleRange['users'] = userCopy;
                                singleRange['fieldCount'] = 0;
                                singleRange['totalFieldWages'] = 0;
                                singleRange['officeCount'] = 0;
                                singleRange['totalOffileWages'] = 0;
                                singleRange['totalsWages'] = 0;
                                singleRange['totalsPTO'] = 0;
                                singleRange['extPayrollTaxes'] = 0;
                                singleRange['extWorkComp'] = 0;
                                singleRange['submitedDate'] = null;

                                let userPromisses = [];
                                angular.forEach(userCopy, function (user) {
                                    let deferred = $q.defer();

                                    let hoursPromisses = [];
                                    angular.forEach(user['hoursData'], function (hour) {
                                        hoursPromisses.push($scope.getPayRollTaxTotals(hour));
                                    });

                                    // hours promisses
                                    $q.all(hoursPromisses).then(function (hours) {
                                        user['hoursData'] = hours;
                                        userPromisses.push(deferred.promise);
                                    });
                                });

                                $q.all(userPromisses).then(function (res) {
                                    _.each(singleRange['users'], (userHours, index2) => {
                                        let fieldHours = 0;
                                        let payrollTaxes = 0;
                                        let payrollCamp = 0;
                                        let hoursTotals = 0;

                                        if (singleRange['users'][index2]['hoursData'].length) {
                                            _.each(singleRange['users'][index2]['hoursData'], data => {
                                                if (!isNaN(data['hours'])) {
                                                    fieldHours += angular.copy(data['hours']);
                                                }
                                                !isNaN(data['hours']) && (userHours['hours'] += data['hours']);
                                                !isNaN(data['hours_over_time']) && (userHours['hours_over_time'] += angular.copy(Number(data['hours_over_time'])));
                                                !isNaN(data['hours_double_time']) && (userHours['hours_double_time'] += angular.copy(Number(data['hours_double_time'])));
                                                !isNaN(data['production_bonus']) && (userHours['production_bonus'] += angular.copy(Number(data['production_bonus'])));
                                                !isNaN(data['extra_break_money']) && (userHours['extra_break_money'] += angular.copy(Number(data['extra_break_money'])));
                                                !isNaN(data['premium_overtime']) && (userHours['premium_overtime'] += angular.copy(Number(data['premium_overtime'])));

                                                payrollTaxes += angular.copy(data['payroll_taxes']);
                                                payrollCamp += angular.copy(data['workers_comp']);
                                                hoursTotals += angular.copy(data['pay_total']);

                                            });
                                        }

                                        let officeHours = (isNaN(userHours['officeHours']) ? 0 : userHours['officeHours']);
                                        let officeHourRate = (isNaN(userHours['officeHourRate']) ? 0 : userHours['officeHourRate']);
                                        let officeHoursOverTime = (isNaN(userHours['officeHoursOverTime']) ? 0 : userHours['officeHoursOverTime']);
                                        let officeHoursDoubleTime = (isNaN(userHours['officeHoursDoubleTime']) ? 0 : userHours['officeHoursDoubleTime']);
                                        let officeBonus = (isNaN(userHours['officeBonus']) ? 0 : userHours['officeBonus']);
                                        let officePayTotals = (officeHours * officeHourRate) + (officeHoursOverTime * officeHourRate * 0.5) + (officeHoursDoubleTime * officeHourRate);

                                        singleRange['totalOffileWages'] += (officePayTotals + officeBonus + userHours['salary']);
                                        singleRange['totalFieldWages'] += hoursTotals;

                                        if (userHours['salary'] > 0 || officeHours > 0) {
                                            singleRange['officeCount'] += 1;
                                        } else {
                                            singleRange['fieldCount'] += 1;
                                        }

                                        // PTO Hours total added to totals wages
                                        let PTOHours = (isNaN(Number(userHours['ptoHourAcc']['hourWorked'])) ? 0 : Number(userHours['ptoHourAcc']['hourWorked']));
                                        let PTORate = (isNaN(Number(userHours['ptoHourAcc']['hourAccured'])) ? 0 : Number(userHours['ptoHourAcc']['hourAccured']));
                                        singleRange['totalsPTO'] += (PTOHours * PTORate);
                                        userHours['pay_total'] = userHours['salary'] + hoursTotals + officePayTotals + officeBonus + (PTOHours * PTORate);
                                        singleRange['totalsWages'] += userHours['pay_total'];


                                        // office tax and field info tax

                                        let officeWCRate = 0;
                                        if (!isNaN(Number(userHours['officeWCRate'])) && Number(userHours['officeWCRate']) !== 0) {
                                            let wcRate = angular.copy(userHours['officeWCRate']);
                                            officeWCRate = (wcRate / 100);
                                        }
                                        let officeWagesTaxes = officePayTotals * Number($scope.users_trade_account.costs.payroll_taxes);
                                        let pTOHoursTaxes = ((PTOHours * PTORate) * Number($scope.users_trade_account.costs.payroll_taxes));
                                        let salaryTax = (Number(userHours['salary'])  * Number($scope.users_trade_account.costs.payroll_taxes));
                                        let officeWorkCompTaxes = officePayTotals * Number(officeWCRate);

                                        singleRange['extPayrollTaxes'] += (payrollTaxes + officeWagesTaxes + pTOHoursTaxes + salaryTax);
                                        singleRange['extWorkComp'] += (payrollCamp + officeWorkCompTaxes);

                                        userHours['payroll_taxes'] = (payrollTaxes + officeWagesTaxes + pTOHoursTaxes + salaryTax);
                                        userHours['workers_comp'] = (payrollCamp + officeWorkCompTaxes);
                                    });
                                });
                            }
                        });

                    });

                });
            }

            $scope.getPayRollTaxTotals = function (hours) {

                let deferred = $q.defer();
                hours.pay_total = costTotalService.getTotal(hours);
                let projectData = $scope.tradeProjects[hours.project_id][0];
                // hours.project_details = JSON.parse(JSON.stringify(projectData));

                if (!hours.task_details.length) {
                    deferred.reject('task details not found');
                    return deferred.promise;
                }

                if (hours.task_details[0].plan_code !== 'T&M') {

                    if (!hours.task_details[0].project_bid_id) {

                        ProjectBids.query({
                            'trade': hours.trade,
                            'task_code': hours.task_details[0].task_code,
                            'plan_code': hours.task_details[0].plan_code,
                            'project_id': projectData._id
                        }, function (project_bid) {

                            if (project_bid.length !== 1) {
                                project_bid = $filter('filter')(project_bid, { 'latest': true }, true);
                                if (project_bid.length !== 1) {
                                    deferred.reject('task details not found');
                                    return deferred.promise;
                                };
                            }

                            var costs = {};
                            if (project_bid[0].latest) {
                                costs = projectData.trades[0].company_factors;
                            } else {
                                costs = projectData.trades[0].revisions[project_bid[0].revision - 1].company_factors;
                            }

                            hours.payroll_taxes = costTotalService.getPayrollTaxes(hours.pay_total, costs);
                            hours.workers_comp = costTotalService.getWorkersComp(hours, costs);
                            deferred.resolve(hours);
                        });
                    } else {

                        var lot = $filter('filter')(projectData.lots, {
                            'number': hours.task_details[0].lot,
                            'phase': hours.task_details[0].phase,
                            'plan': hours.task_details[0].plan_code
                        }, true);
                        var myInfo = $filter('filter')(lot[0].revisions, { 'trade': $scope.user.trade[0] }, true);
                        var projTrade = $filter('filter')(projectData.trades, { 'name': $scope.user.trade[0] }, true);

                        var costs = {};
                        if (!myInfo[0]) {
                            costs = projectData.trades[0].company_factors;
                        } else if (myInfo[0].revision === projTrade[0].revisions.length + 1) {
                            costs = projectData.trades[0].company_factors;
                        } else {
                            if (myInfo[0].revision === 0) {
                                costs = projectData.trades[0].company_factors;
                            } else {
                                costs = projectData.trades[0].revisions[myInfo[0].revision - 1].company_factors;
                            }
                        }

                        hours.payroll_taxes = costTotalService.getPayrollTaxes(hours.pay_total, costs);
                        hours.workers_comp = costTotalService.getWorkersComp(hours, costs);
                        deferred.resolve(hours);
                    }
                } else {
                    var trade = $filter('filter')(projectData.trades, { 'name': hours.trade }, true);
                    hours.payroll_taxes = costTotalService.getPayrollTaxes(hours.pay_total, trade[0].company_factors);
                    hours.workers_comp = costTotalService.getWorkersComp(hours, trade[0].company_factors);
                    deferred.resolve(hours);
                }

                return deferred.promise;
            };

            $scope.savePayroll = function () {
                let newDocData = {};


                // update saved records
                if ($scope.selParollPeriod.hasOwnProperty('_id')) {
                    ngDialog.openConfirm({
                        template:
                            '<h2>Payroll Process</h2>' +
                            '<p>This operation will remove all the previous payroll transaction and create new transaction for user payroll.</p>' +
                            '<p><br><t><strong>Do you wish to continue?</strong></p>' +
                            '<div>' +
                            '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                            '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                            '</button></div>',
                        plain: true,
                        className: 'ngdialog-theme-default'
                    }).then(function (value) {
                        if (value !== 0) {
                            $scope.selParollPeriod.$update(function (docs) {
                                toaster.pop('success', 'Payroll Updated', 'Payroll transaction updated successfully.');
                            });
                        }
                    });
                    return;
                }

                $scope.selParollPeriod['trade'] = $scope.user.trade[0];
                $scope.selParollPeriod['mainAccountId'] = $scope.clientAccountId;
                $scope.selParollPeriod['company_code'] = $scope.user.contractor_code;
                $scope.selParollPeriod['submitedDate'] = new Date();
                $scope.showSpinner = true;

                var newDocs = new PayrollProcess($scope.selParollPeriod);
                newDocs.$save(function (results) {
                    $scope.selParollPeriod = results;
                    toaster.pop('success', 'Process Complete', 'Payroll data saved successfully.');
                    $scope.showSpinner = false;
                });
            }
            $scope.editPayroll = function (indexNo) {
                $scope.selectedTabs = 'details';
                PayrollProcess.query({
                    start: $scope.selDateRange[indexNo].start,
                    end: $scope.selDateRange[indexNo].end,
                    type: 'editPayroll'
                }, function (doc) {
                    if (doc.length) {
                        $scope.selParollPeriod = doc[0];
                    } else {
                        $scope.selParollPeriod = $scope.selDateRange[indexNo];
                    }
                });
            }
            $scope.parollBack = function () {
                $scope.selectedTabs = 'process';
                $scope.selParollPeriod = null;
                $scope.selDateRange = [];
                $scope.getPayrollEmployee();
            }

            $scope.addPayrollRule = function () {

                $scope.selectedRule = {
                    mainAccountId: $scope.clientAccountId,
                    name: '',
                    appliedTo: '',
                    dataPoint: '',
                    debitAccounts: [{
                        account: null,
                        accPerc: 0
                    }],
                    creditAccounts: [{
                        account: null,
                        accPerc: 0
                    }],
                };

                ngDialog.openConfirm({
                    template: 'accounting/views/payrolls/addRule.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg employeeInfo'
                }).then(function (value) {
                    var newRule = new PayrollRules(value);
                    newRule.$save(function (doc) {
                        toaster.pop('success', 'New Rule Added', 'Rule added successfully.');
                        $scope.selectedRule = null;
                        $scope.getPayrollRules();
                    });
                }, function (value) {
                    $scope.selectedRule = null;
                });
            }

            $scope.getPayrollRules = function () {
                PayrollRules.query({
                    'mainAccountId': $scope.clientAccountId
                }, function (rules) {
                    $scope.payrollRules = rules;
                });
            }

            $scope.addAccount = function (accountKey) {
                $scope.selectedRule[accountKey].push({ account: null, accPerc: 0 });
            }

            $scope.validatePercTotals = function () {
                var cTotals = $scope.selectedRule.creditAccounts.reduce(function (total, { accPerc }) {
                    return !isNaN(accPerc) ? (Number(total) + Number(accPerc)) : Number(total);
                }, 0);
                var dTotals = $scope.selectedRule.debitAccounts.reduce(function (total, { accPerc }) {
                    return !isNaN(accPerc) ? (Number(total) + Number(accPerc)) : Number(total);
                }, 0)
                return (Number(cTotals) !== Number(dTotals));
            }

            $scope.deletePayrollRule = function (rule) {
                rule.$remove(function (doc) {
                    $scope.getPayrollRules();
                });
            }

            $scope.editPayrollRule = function (rule) {
                $scope.selectedRule = angular.copy(rule);
                ngDialog.openConfirm({
                    template: 'accounting/views/payrolls/addRule.html',
                    scope: $scope,
                    className: 'ngdialog-theme-default ngdialg-padding ngdialog-lg employeeInfo'
                }).then(function (value) {
                    value.$update(function (docs) {
                        toaster.pop('success', 'Rule updated', 'Rule updated successfully.');
                        $scope.selectedRule = null;
                        $scope.getPayrollRules();
                    });
                }, function (value) {
                    $scope.selectedRule = null;
                });
            }

            /**
             * @description convert to csv
             */
            $scope.ConvertToCSV = function (objArray) {
                var array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;                
                var str = 'Employee Name, Employee Number, Phone Number, Email,  Hired Date, Field Hourly Rate, Office Hourly Rate, Annual Salary, Sick/PTO Per, Hours Workerd, Sick/PTO Max, Cost Centers, Field W/C Code, Field W/C Rate, Office W/C Code, Office W/C Rate, Status';
                str += '\r\n';
                for (var i = 0; i < array.length; i++) {
                    str += (array[i].name || '') + ', ' + (array[i].username || '') + ', ' + (array[i].phone || '') + ', ' + (array[i].email || '') +   ', ' + ((!!array[i].hiredDate) ? moment(array[i].hiredDate).format('MM/DD/YYYY') : '') + ', ' + (array[i].pay_rate || 0) + ',' + (array[i].officeHourRate || 0) + ',';
                    str += (array[i].annualSalary || 0) + ', ' + (array[i].ptoHourAcc.hourAccured || 0) + ', ' + (array[i].ptoHourAcc.hourWorked || 0) + ', ' + (array[i].sickPtoMax || 0) + ', ' + (array[i].costCenter || '') + ', ' + (array[i].fieldClassCode || '') + ', ';
                    str += (array[i].fieldWCRate || 0) + ', ' + (array[i].officeClassCode || 0) +  ', ' + (array[i].officeWCRate || 0) + ', ' + ((!!array[i].active) ? 'Active' : 'Inactive');
                    str += '\r\n';
                }
                var uri = encodeURIComponent(str);
                return uri;
            };

            /**
            * @description export csv file
            */
            $scope.exportFile = function () {
                var dataUrl = 'data:text/csv;charset=utf-8,' + ($scope.ConvertToCSV($scope.employeeList));
                var link = document.createElement('a');
                angular.element(link)
                    .attr('href', dataUrl)
                    .attr('download', 'employee-list.csv'); // Pretty much only works in chrome
                link.click();
            };

            /**
             * @description import selected file
             */
            $scope.fileSelected = function () {
                var payload = {},
                    _self = this,
                    importedCsv = this.$parent.fileContent.split('\n');
                payload.contractor_code = $scope.user.contractor_code;
                payload.trade = $scope.user.trade[0];
                payload.employee = importedCsv;
                $http.post(importEmployeeAPI, payload).
                    success(function () {
                        toaster.pop('success', 'Data imported successfully.');
                        $scope.getEmployeeList();
                        delete _self.$parent.fileContent;
                    }).
                    error(function (error) {
                        var title = 'Rejected Import, fix, and retry.',
                            message = '';
                        if (error.error && error.error.length) {
                            var linenumber = 0
                            error.error.map(function (error, index) {
                                linenumber = index + 1;
                                var errormsg = '<b>' + linenumber + '. ' + error + '.</b> <br><br>';
                                message = message.concat(errormsg);
                            });
                            var height = linenumber > 10 ? 500 : 50 * linenumber;
                            height = height + 'px';
                            message = '<div class="toster-msg-trans" style="height:' + height + '">' + message + '</div>'
                        } else {
                            message = error;
                        }
                        toaster.pop({
                            'type': 'error',
                            'title': title,
                            'body': message,
                            'bodyOutputType': 'trustedHtml',
                            'timeout': 0,
                            'showCloseButton': true
                        });
                        $scope.getEmployeeList();
                        delete _self.$parent.fileContent;
                    });
            };

        }
    ]);





// WEBPACK FOOTER //
// ./packages/custom/accounting/public/controllers/payrolls.js